// core
import React from 'react';
import { Link } from "react-router-dom";

// confs
import conf from 'conf/ajax';


export default function TagLink({tag})
{
    const name = tag.name;
    const url = conf.route.answer + `?tag=${tag.id}`;

    if (tag.id)
    {
        return (
            <Link className="tag-link link-icon" to={url} title="View all questions in this tag"><i className="fa-solid fa-tag"></i> <span>{name}</span></Link>
        )
    }
    else
    {
        return (
            <span>{name}</span>
        )
    }
}

TagLink.defaultProps =
{
    author: {
        name: '',
        id: ''
    }
};
